/* tslint:disable:import-spacing no-inferrable-types variable-name align no-trailing-whitespace */

import * as THREE        from 'three';

/**
 *
 * @class ViewMemento
 *
 * @brief encapsulation of how the main viewer is configured, camera position, what part of
 * the main graph is shown on screen etc.  This memento can be used by clients of the main
 * view to tell the viewer how to position/configure itself.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      November 2019
 *
 */
export class ViewMemento {

  /** @var _worldBound THREE.Box2 the currently part fo the graph */
  public    _worldBound: THREE.Box2              = null;

  /** @var _screenBound THREE.Box2 the screen projected version of _worldBound */
  public   _screenBound: THREE.Box2              = null;

  /** @var _graph THREE.Box2 the world bound of the complete graph */
  public         _graph: THREE.Box2              = null;

  /** @var _screenGraph THREE.Box2 the screen projected version of _graph */
  public   _screenGraph: THREE.Box2              = null;

  /** @var _camera THREE.Vector3 current camera position */
  public        _camera: THREE.Vector3                = null;

  /** @var _timeScale number the geometric scaling of the graph (horizontal) */
  public     _timeScale: number = 1.0;

  /** @var _distanceScale number the geometric scaling of the graph (vertical) */
  public _distanceScale: number = 1.0;

  /** @brief standard constructor */
  constructor(      world: THREE.Box2,
                   screen: THREE.Box2,
                    graph: THREE.Box2,
              screenGraph: THREE.Box2,
                   camera: THREE.Vector3,
                   xScale: number,
                   yScale: number) {

    this._worldBound    = world;
    this._screenBound   = screen;
    this._graph         = graph;
    this._screenGraph   = screenGraph;
    this._camera        = camera;
    this._timeScale     = xScale;
    this._distanceScale = yScale;
  }

}
